export default {
  goldenConfetti: () => import('./golden-confetti.json'),
};
